<p>externaluserredirection works!</p>
